import { Card, CardBody } from 'components/card';
import { CardHeader, CardHeaderTitle } from 'components/card/card-header';
import FormEditHeaderButtons from 'containers/partials/buttons/FormEditHeaderButtons';
import FormEditFooterButtons from 'containers/partials/buttons/FormEditFooterButtons';
import InjuryForm from 'containers/pages/rehab/injury/InjuryForm';
import InjuryDetailFields from 'containers/pages/rehab/injury/InjuryDetailFields';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import useEdit from 'hooks/utils/useEdit';
import InjuryDetailMoreFields from 'containers/pages/rehab/injury/InjuryDetailMoreFields';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import { useContext, useEffect } from 'react';
import { StoreContext } from 'index';
import { useParams } from 'react-router-dom';
import RemovePersonInjuryButton from 'containers/partials/buttons/RemoveInjuryButton';

function InjuriesDetailsTab({ personInjury, medical, ...props }) {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { entityId, groupId, personId, injuryId } = useParams();
  const { setMenuItems, clearAllContext } = useContextMenu();
  const [edit, setEdit] = useEdit(props.edit, true);

  useEffect(() => {
    const contextMenuItems = [];
    if (user.canRemovePersonInjury(entityId)) {
      contextMenuItems.push(
        <RemovePersonInjuryBtn key="remove-person-injury-btn" />
      );
    }
    setMenuItems(contextMenuItems);
    return () => clearAllContext();
  }, [entityId, injuryId]);

  const RemovePersonInjuryBtn = () => (
    <RemovePersonInjuryButton
      menu
      entityId={entityId}
      personId={personId}
      groupId={groupId}
      personInjuryId={injuryId}
    >
      <FormattedMessage {...messages.rehabMenuItemRemovePersonInjury} />
    </RemovePersonInjuryButton>
  );

  return (
    <Card secondary>
      <InjuryForm
        entityId={entityId}
        personId={personId}
        personInjury={personInjury}
        medical={medical}
      >
        {({ submitForm, resetForm }) => (
          <>
            <CardHeader secondary>
              <CardHeaderTitle>
                <FormattedMessage {...messages.titleInjuryDetails} />
              </CardHeaderTitle>
              <FormEditHeaderButtons
                edit={edit}
                setEdit={setEdit}
                onCancel={resetForm}
                onSubmit={submitForm}
                type={'button'}
              />
            </CardHeader>
            <CardBody secondary>
              <div className="o-layout o-layout--small">
                <InjuryDetailFields edit={edit} />
                <InjuryDetailMoreFields
                  edit={edit}
                  showMore={personInjury.hasMoreInfo}
                />
              </div>
            </CardBody>
            <FormEditFooterButtons
              edit={edit}
              setEdit={setEdit}
              onCancel={resetForm}
              onSubmit={submitForm}
              type={'button'}
            />
          </>
        )}
      </InjuryForm>
    </Card>
  );
}

export default InjuriesDetailsTab;
